export const LAST_SUCCESS_TS_KEY = 'nwl:lastSuccessAtISO';
export const LAST_SUCCESS_PHASE_KEY = 'nwl:lastSuccessPhase';
export const LAST_SUCCESS_KIND_KEY = 'nwl:lastSuccessKind'; // 'IN_PROGRESS' | 'COMPLETED'
export const NEXT_SIM_EPOCH_KEY = 'nwl:nextSimulationEpoch';

/** Convert to a Date. */
const toDate = (x?: Date | number | string): Date => {
  if (x instanceof Date) return x;
  if (typeof x === 'number') return new Date(x > 1e12 ? x : x * 1000);
  if (typeof x === 'string') return new Date(x);
  return new Date();
};

const headStatus = (payload: any) =>
  payload?.data?.[0]?.summary?.status as 'COMPLETED' | 'IN_PROGRESS' | 'FAILED' | undefined;

const currentPhase = () => {
  const p = localStorage.getItem(NEXT_SIM_EPOCH_KEY);
  return p ? String(p) : null;
};

/**
 * Write once per phase on COMPLETED.
 * Additionally: allow a single per-session IN_PROGRESS capture *only if nothing is saved yet*.
 */
export function lockFirstSuccessCompletedSimTime(
  payload: any,
  now: Date | number | string = new Date()
): Date | undefined {
  const status = headStatus(payload);
  if (status !== 'IN_PROGRESS' && status !== 'COMPLETED') return undefined;

  const phase = currentPhase();
  const savedIso   = localStorage.getItem(LAST_SUCCESS_TS_KEY);
  const savedPhase = localStorage.getItem(LAST_SUCCESS_PHASE_KEY);
  const savedKind  = localStorage.getItem(LAST_SUCCESS_KIND_KEY);
  const samePhase  = !!phase && savedPhase === phase;

  const parseSaved = (): Date | undefined => {
    const iso = localStorage.getItem(LAST_SUCCESS_TS_KEY);
    if (!iso) return undefined;
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? undefined : d;
  };

  const write = (stamp: Date, kind: 'IN_PROGRESS' | 'COMPLETED') => {
    const currentKind = localStorage.getItem(LAST_SUCCESS_KIND_KEY);

    // Only block downgrading within the same phase
    if (samePhase && currentKind === 'COMPLETED' && kind !== 'COMPLETED') {
      return parseSaved();
    }

    localStorage.setItem(LAST_SUCCESS_TS_KEY, stamp.toISOString());
    if (phase) localStorage.setItem(LAST_SUCCESS_PHASE_KEY, phase);
    localStorage.setItem(LAST_SUCCESS_KIND_KEY, kind);
    window.dispatchEvent(new Event('nwl:last-success-updated'));
    return stamp;
  };

  // COMPLETED: write once per phase, else return stored COMPLETED
  if (status === 'COMPLETED') {
    if (samePhase && savedIso && savedKind === 'COMPLETED') {
      return parseSaved();
    }
    return write(toDate(now), 'COMPLETED');
  }

  // IN_PROGRESS: if we already have anything, surface it; else stamp once
  if (savedIso) return parseSaved();
  return write(toDate(now), 'IN_PROGRESS');
}

